<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4">
        <v-select
          label="Idade mínima desacompanhado"
          :items="ageOptions"
          required
          outlined
          dense
          hide-details
          v-model="policies.ageGroup"
          :value="policies.ageGroup"
          item-text="text"
          item-value="value"
          :disabled="party.techniciansOnly && !user.MasterPermission"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          label="Idade mínima acompanhado"
          :items="ageOptionsWithParent"
          required
          outlined
          dense
          hide-details
          v-model="policies.ageWithParent"
          :disabled="
            policies.ageGroup === 0 ||
            (party.techniciansOnly && !user.MasterPermission)
          "
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          label="Idade grátis"
          :items="ageFreeOptions"
          required
          outlined
          dense
          hide-details
          v-model="policies.ageFree"
          :disabled="party.techniciansOnly && !user.MasterPermission"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        class="pt-1"
        v-if="policies.ageGroup < 18 || policies.ageWithParent != -1"
      >
        <v-file-input
          v-if="!party.authorizationTemplate"
          v-model="pdf"
          label="Template autorização para menores"
          accept=".pdf"
          outlined
          hide-details
          dense
          :disabled="party.techniciansOnly && !user.MasterPermission"
        ></v-file-input>

        <v-alert class="mb-0" v-else type="info" dense text>
          <div class="d-flex w-full align-center justify-space-between">
            <span> Template de autorização para menores já cadastrado. </span>
            <v-btn
              v-if="!party.techniciansOnly || user.MasterPermission"
              depressed
              small
              @click="party.authorizationTemplate = null"
            >
              Remover
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-alert type="info" dense text border="left">
      <age-group-text :party="policies" />
    </v-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PARTY from "@/services/admin/party";

import AgeGroupText from "../../../global/party/AgeGroupText.vue";
export default {
  components: { AgeGroupText },
  data() {
    return {
      pdf: null,
      ageOptions: [
        { text: "18 anos", value: 18 },
        { text: "17 anos", value: 17 },
        { text: "16 anos", value: 16 },
        { text: "15 anos", value: 15 },
        { text: "14 anos", value: 14 },
        { text: "13 anos", value: 13 },
        { text: "12 anos", value: 12 },
        { text: "11 anos", value: 11 },
        { text: "10 anos", value: 10 },
        { text: "9 anos", value: 9 },
        { text: "8 anos", value: 8 },
        { text: "7 anos", value: 7 },
        { text: "6 anos", value: 6 },
        { text: "5 anos", value: 5 },
        { text: "4 anos", value: 4 },
        { text: "3 anos", value: 3 },
        { text: "2 anos", value: 2 },
        { text: "1 ano", value: 1 },
        { text: "Livre", value: 0 },
      ],
      policies: {
        ageGroup: this.party?.ageGroup === 0 ? 0 : this.party?.ageGroup || 18,
        ageWithParent: this.party?.ageWithParent || 0,
        ageFree: this.party?.ageFree || 0,
        authorizationTemplate: this.party?.authorizationTemplate,
      },
    };
  },
  methods: {
    async save() {
      const ageGroupToSend =
        this.policies.ageGroup === "Livre" ? 0 : this.policies.ageGroup;

      const hasAuthorization = this.party.authorizationTemplate || this.pdf;
      const partyUpdate = await PARTY.update({
        id: this.party.id,
        organizationId: this.party.organizationId,
        ageGroup: ageGroupToSend,
        ageWithParent: this.policies.ageWithParent,
        ageFree: this.policies.ageFree,
        authorizationTemplate: hasAuthorization ? undefined : null,
      });

      if (this.pdf) await this.authorization();

      return partyUpdate;
    },
    authorization() {
      return PARTY.document(
        this.party.organizationId,
        this.party.id,
        "authorization-template",
        this.pdf
      );
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    minAge() {
      return Math.min(
        this.policies.ageGroup || 18,
        this.policies.ageWithParent === -1
          ? Infinity
          : this.policies.ageWithParent
      );
    },
    ageOptionsWithParent() {
      const options = this.ageOptions.filter(
        (option) => option.value < this.policies.ageGroup
      );

      if (this.policies.ageGroup !== 0)
        options.push({
          text: "Não permitido",
          value: -1,
        });

      return options;
    },
    ageFreeOptions() {
      const options = this.ageOptions.filter(
        (option) =>
          option.value >= this.minAge && option.value > 0 && option.value < 16
      );

      options.push({
        text: "Não permitido",
        value: 0,
      });

      return options;
    },
  },
  watch: {
    minAge: {
      handler: function (val) {
        const indexFree = this.ageFreeOptions.findIndex(
          (option) => option.value === val
        );
        if (indexFree === -1) this.policies.ageFree = 0;
      },
    },
    party: {
      handler: function (val, oldVal) {
        this.policies.ageGroup = val.ageGroup || 18;
        this.policies.ageWithParent = val.ageWithParent || 0;
        this.policies.ageFree = val.ageFree || 0;
      },
      deep: true,
    },
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
